import { useMemo } from 'react';
import { createItems, hasRunToday, mobileRole, mobileTabs, myRunsRange } from '@tradeoutlet/shared';
import { useMyRuns } from '@tradeoutlet/data';
import { useWorkspaceId } from '@/lib/hooks';
import { holdsAnywhere } from '@/lib/navAccess';
import { usePermissions } from '@/lib/permissions';

/** The role-shaped tabs and ＋ items for the signed-in person (rules in @tradeoutlet/shared mobile/shell). */
export function useMobileTabs() {
  const ws = useWorkspaceId();
  const mine = usePermissions().data;
  const holds = useMemo(() => (p: string) => holdsAnywhere(mine, p), [mine]);
  // Same range as the Runs tab (one request): the API's `to` is exclusive, so to=today would miss today's runs.
  const [from, to] = myRunsRange();
  const off = mine?.modules_off;
  const runs = useMyRuns(ws, from, to, holds('fleet.drive') && !off?.includes('fleet'));
  // t369u: switched-off modules lose their tabs and ＋ rows; the rest reflow.
  const role = mobileRole(holds, { runToday: hasRunToday(runs.data ?? []), off });
  return { role, slots: mobileTabs(role, off), create: createItems(role, holds, off) };
}
